import { render, staticRenderFns } from "./BookingMesa.vue?vue&type=template&id=4b1d5def&scoped=true"
import script from "./BookingMesa.vue?vue&type=script&lang=js"
export * from "./BookingMesa.vue?vue&type=script&lang=js"
import style0 from "./BookingMesa.vue?vue&type=style&index=0&id=4b1d5def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d5def",
  null
  
)

export default component.exports